import { ITEM_DEFS } from './item-defs.js';

function makeToolRecipe(outId, matItemId, idSuffix = '') {
  const isShovel = outId.includes('shovel');
  const isPickaxe = outId.includes('pickaxe');
  const isSword = outId.includes('sword');
  const isHoe = outId.includes('hoe');
  return {
    id: `${outId}${idSuffix}`,
    name: ITEM_DEFS[outId]?.name || outId,
    station: 'table',
    pattern: isPickaxe
      ? ['MMM', ' S ', ' S ']
      : isShovel
        ? ['M', 'S', 'S']
        : isSword
          ? ['M', 'M', 'S']
          : isHoe
            ? ['MM', ' S', ' S']
          : ['MM', 'MS', ' S'],
    key: { M: matItemId, S: 'stick' },
    output: { [outId]: 1 },
    mirror: !isPickaxe && !isShovel && !isSword
  };
}

function makeArmorRecipe(outId, matItemId) {
  const slot = ITEM_DEFS[outId]?.armorSlot;
  if (!slot) return null;

  const patterns = {
    helmet: ['MMM', 'M M'],
    chestplate: ['M M', 'MMM', 'MMM'],
    leggings: ['MMM', 'M M', 'M M'],
    boots: ['M M', 'M M']
  };

  return {
    id: outId,
    name: ITEM_DEFS[outId]?.name || outId,
    station: 'table',
    pattern: patterns[slot] || ['M'],
    key: { M: matItemId },
    output: { [outId]: 1 }
  };
}

export const RECIPES = [
  {
    id: 'camphor_planks',
    name: 'Camphor Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '78' },
    output: { '87': 4 }
  },
  {
    id: 'banyan_planks',
    name: 'Banyan Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '79' },
    output: { '88': 4 }
  },
  {
    id: 'nanmu_planks',
    name: 'Nanmu Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '80' },
    output: { '89': 4 }
  },
  {
    id: 'birch_planks',
    name: 'Birch Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '81' },
    output: { '90': 4 }
  },
  {
    id: 'cypress_planks',
    name: 'Cypress Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '82' },
    output: { '91': 4 }
  },
  {
    id: 'maple_planks',
    name: 'Maple Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '83' },
    output: { '92': 4 }
  },
  {
    id: 'conifer_planks',
    name: 'Conifer Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '84' },
    output: { '93': 4 }
  },
  {
    id: 'juniper_planks',
    name: 'Juniper Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '85' },
    output: { '94': 4 }
  },
  {
    id: 'fir_planks',
    name: 'Fir Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: '86' },
    output: { '95': 4 }
  },
  {
    id: 'planks',
    name: 'Planks',
    station: 'hand',
    pattern: ['L'],
    key: { L: { group: 'tree_logs' } },
    output: { '6': 4 }
  },
  {
    id: 'sticks',
    name: 'Sticks',
    station: 'hand',
    pattern: ['P', 'P'],
    key: { P: '6' },
    output: { stick: 4 }
  },
  {
    id: 'wool',
    name: 'Wool',
    station: 'hand',
    pattern: ['SS', 'SS'],
    key: { S: 'string' },
    output: { wool: 1 }
  },
  {
    id: 'bone_meal',
    name: 'Bone Meal',
    station: 'hand',
    pattern: ['B'],
    key: { B: 'bone' },
    output: { bone_meal: 3 }
  },
  {
    id: 'wheat_seed',
    name: 'Wheat Seeds',
    station: 'hand',
    pattern: ['W'],
    key: { W: 'wheat' },
    output: { wheat_seed: 2 }
  },
  {
    id: 'wheat_from_hay_bale',
    name: 'Wheat',
    station: 'hand',
    pattern: ['H'],
    key: { H: '68' },
    output: { wheat: 5 }
  },
  {
    id: 'crafting_table',
    name: 'Crafting Table',
    station: 'hand',
    pattern: ['PP', 'PP'],
    key: { P: '6' },
    output: { '11': 1 }
  },
  {
    id: 'torch',
    name: 'Torch',
    station: 'hand',
    pattern: ['C', 'S'],
    key: { C: 'coal', S: 'stick' },
    output: { torch: 4 }
  },
  {
    id: 'torch_charcoal',
    name: 'Torch',
    station: 'hand',
    pattern: ['C', 'S'],
    key: { C: 'charcoal', S: 'stick' },
    output: { torch: 4 }
  },
  {
    id: 'chest',
    name: 'Chest',
    station: 'table',
    pattern: ['PPP', 'P P', 'PPP'],
    key: { P: '6' },
    output: { '14': 1 }
  },
  {
    id: 'bed',
    name: 'Bed',
    station: 'table',
    pattern: ['WWW', 'PPP'],
    key: { W: 'wool', P: '6' },
    output: { '15': 1 }
  },
  {
    id: 'bread',
    name: 'Bread',
    station: 'table',
    pattern: ['WWW'],
    key: { W: 'wheat' },
    output: { bread: 1 }
  },
  {
    id: 'oak_door',
    name: 'Oak Door',
    station: 'table',
    pattern: ['PP', 'PP', 'PP'],
    key: { P: '6' },
    output: { '16': 3 }
  },
  {
    id: 'trapdoor',
    name: 'Trapdoor',
    station: 'table',
    pattern: ['PPP', 'PPP'],
    key: { P: '6' },
    output: { '18': 2 }
  },
  {
    id: 'fence',
    name: 'Fence',
    station: 'table',
    pattern: ['PSP', 'PSP'],
    key: { P: '6', S: 'stick' },
    output: { '20': 3 }
  },
  {
    id: 'sandstone',
    name: 'Sandstone',
    station: 'table',
    pattern: ['SS', 'SS'],
    key: { S: '26' },
    output: { '21': 1 }
  },
  {
    id: 'stone_bricks',
    name: 'Stone Bricks',
    station: 'table',
    pattern: ['SS', 'SS'],
    key: { S: '5' },
    output: { '29': 4 }
  },
  {
    id: 'red_bricks',
    name: 'Red Brick',
    station: 'table',
    pattern: ['BB', 'BB'],
    key: { B: '22' },
    output: { '77': 4 }
  },
  {
    id: 'mossy_cobblestone',
    name: 'Mossy Cobblestone',
    station: 'table',
    pattern: ['CL', 'LC'],
    key: { C: '28', L: '4' },
    output: { '32': 2 }
  },
  {
    id: 'chiseled_stone_bricks',
    name: 'Chiseled Stone Bricks',
    station: 'table',
    pattern: ['S', 'S'],
    key: { S: '29' },
    output: { '33': 1 }
  },
  {
    id: 'coal_block',
    name: 'Coal Block',
    station: 'table',
    pattern: ['CCC', 'CCC', 'CCC'],
    key: { C: 'coal' },
    output: { '35': 1 }
  },
  {
    id: 'coal_unpack',
    name: 'Coal',
    station: 'hand',
    pattern: ['B'],
    key: { B: '35' },
    output: { coal: 9 }
  },
  {
    id: 'iron_block',
    name: 'Iron Block',
    station: 'table',
    pattern: ['III', 'III', 'III'],
    key: { I: 'iron_ingot' },
    output: { '36': 1 }
  },
  {
    id: 'iron_unpack',
    name: 'Iron Ingot',
    station: 'hand',
    pattern: ['B'],
    key: { B: '36' },
    output: { iron_ingot: 9 }
  },
  {
    id: 'diamond_block',
    name: 'Diamond Block',
    station: 'table',
    pattern: ['DDD', 'DDD', 'DDD'],
    key: { D: 'diamond_gem' },
    output: { '37': 1 }
  },
  {
    id: 'diamond_unpack',
    name: 'Diamond',
    station: 'hand',
    pattern: ['B'],
    key: { B: '37' },
    output: { diamond_gem: 9 }
  },
  {
    id: 'gold_block',
    name: 'Gold Block',
    station: 'table',
    pattern: ['GGG', 'GGG', 'GGG'],
    key: { G: 'gold_ingot' },
    output: { '48': 1 }
  },
  {
    id: 'gold_unpack',
    name: 'Gold Ingot',
    station: 'hand',
    pattern: ['B'],
    key: { B: '48' },
    output: { gold_ingot: 9 }
  },
  {
    id: 'glowstone',
    name: 'Glowstone',
    station: 'table',
    pattern: [' C ', 'GTG', ' C '],
    key: { C: 'coal', G: '23', T: 'torch' },
    output: { '38': 2 }
  },
  {
    id: 'quartz_block',
    name: 'Quartz Block',
    station: 'table',
    pattern: ['SS', 'SS'],
    key: { S: '30' },
    output: { '39': 4 }
  },
  {
    id: 'ender_eye',
    name: 'Eye of Ender',
    station: 'table',
    pattern: [' F ', 'DOD', ' F '],
    key: { F: 'flint', D: 'diamond_gem', O: '31' },
    output: { ender_eye: 2 }
  },
  {
    id: 'flint_and_steel',
    name: 'Flint and Steel',
    station: 'hand',
    shapeless: true,
    ingredients: ['flint', 'iron_ingot'],
    output: { flint_steel: 1 },
  },
  {
    id: 'shears',
    name: 'Shears',
    station: 'hand',
    pattern: [' I', 'I '],
    key: { I: 'iron_ingot' },
    output: { shears: 1 },
    mirror: true
  },
  {
    id: 'bucket',
    name: 'Bucket',
    station: 'table',
    pattern: ['I I', ' I '],
    key: { I: 'iron_ingot' },
    output: { bucket: 1 }
  },
  {
    id: 'asphalt',
    name: 'Asphalt',
    station: 'table',
    pattern: ['SC', 'CS'],
    key: { S: '28', C: 'coal' },
    output: { '25': 2 }
  },
  {
    id: 'furnace',
    name: 'Furnace',
    station: 'table',
    pattern: ['SSS', 'S S', 'SSS'],
    key: { S: '28' },
    output: { '13': 1 }
  },
  {
    id: 'lever',
    name: 'Lever',
    station: 'hand',
    pattern: ['S', 'C'],
    key: { S: 'stick', C: '28' },
    output: { '58': 1 }
  },
  {
    id: 'arrow',
    name: 'Arrow',
    station: 'table',
    pattern: ['C', 'S', 'S'],
    key: { C: 'coal', S: 'stick' },
    output: { arrow: 4 }
  },
  {
    id: 'arrow_feather',
    name: 'Arrow',
    station: 'table',
    pattern: ['F', 'S', 'C'],
    key: { F: 'feather', S: 'stick', C: 'coal' },
    output: { arrow: 8 }
  },
  {
    id: 'arrow_flint',
    name: 'Arrow',
    station: 'table',
    pattern: ['F', 'S', 'E'],
    key: { F: 'flint', S: 'stick', E: 'feather' },
    output: { arrow: 4 }
  },
  {
    id: 'bow',
    name: 'Bow',
    station: 'table',
    pattern: [' ST', 'S T', ' ST'],
    key: { S: 'string', T: 'stick' },
    output: { bow: 1 }
  },
  {
    id: 'shield',
    name: 'Shield',
    station: 'table',
    pattern: ['PIP', 'PPP'],
    key: { P: '6', I: 'iron_ingot' },
    output: { shield: 1 }
  },
  {
    id: 'boat',
    name: 'Boat',
    station: 'table',
    pattern: ['P P', 'PPP'],
    key: { P: '6' },
    output: { boat: 1 }
  },
  {
    id: 'bamboo_raft',
    name: 'Bamboo Raft',
    station: 'table',
    pattern: ['SSS', 'PPP'],
    key: { S: 'stick', P: '6' },
    output: { bamboo_raft: 1 }
  },
  {
    id: 'redstone_dust',
    name: 'Redstone Dust',
    station: 'table',
    pattern: ['CQ', 'QC'],
    key: { C: 'coal', Q: '39' },
    output: { '60': 4 }
  },
  {
    id: 'redstone_lamp',
    name: 'Redstone Lamp',
    station: 'table',
    pattern: [' R ', 'RGR', ' R '],
    key: { R: '60', G: '38' },
    output: { '62': 1 }
  },
  makeToolRecipe('wood_pickaxe', '6'),
  makeToolRecipe('wood_axe', '6'),
  makeToolRecipe('wood_shovel', '6'),
  makeToolRecipe('wood_hoe', '6'),
  makeToolRecipe('wood_sword', '6'),
  makeToolRecipe('stone_pickaxe', '5'),
  makeToolRecipe('stone_axe', '5'),
  makeToolRecipe('stone_shovel', '5'),
  makeToolRecipe('stone_hoe', '5'),
  makeToolRecipe('stone_sword', '5'),
  makeToolRecipe('stone_pickaxe', '28', '_cobble'),
  makeToolRecipe('stone_axe', '28', '_cobble'),
  makeToolRecipe('stone_shovel', '28', '_cobble'),
  makeToolRecipe('stone_hoe', '28', '_cobble'),
  makeToolRecipe('stone_sword', '28', '_cobble'),
  makeToolRecipe('iron_pickaxe', 'iron_ingot'),
  makeToolRecipe('iron_axe', 'iron_ingot'),
  makeToolRecipe('iron_shovel', 'iron_ingot'),
  makeToolRecipe('iron_hoe', 'iron_ingot'),
  makeToolRecipe('iron_sword', 'iron_ingot'),
  makeToolRecipe('gold_pickaxe', 'gold_ingot'),
  makeToolRecipe('gold_axe', 'gold_ingot'),
  makeToolRecipe('gold_shovel', 'gold_ingot'),
  makeToolRecipe('gold_hoe', 'gold_ingot'),
  makeToolRecipe('gold_sword', 'gold_ingot'),
  makeToolRecipe('diamond_pickaxe', 'diamond_gem'),
  makeToolRecipe('diamond_axe', 'diamond_gem'),
  makeToolRecipe('diamond_shovel', 'diamond_gem'),
  makeToolRecipe('diamond_hoe', 'diamond_gem'),
  makeToolRecipe('diamond_sword', 'diamond_gem'),
  makeArmorRecipe('leather_helmet', 'leather'),
  makeArmorRecipe('leather_chestplate', 'leather'),
  makeArmorRecipe('leather_leggings', 'leather'),
  makeArmorRecipe('leather_boots', 'leather'),
  makeArmorRecipe('iron_helmet', 'iron_ingot'),
  makeArmorRecipe('iron_chestplate', 'iron_ingot'),
  makeArmorRecipe('iron_leggings', 'iron_ingot'),
  makeArmorRecipe('iron_boots', 'iron_ingot'),
  makeArmorRecipe('gold_helmet', 'gold_ingot'),
  makeArmorRecipe('gold_chestplate', 'gold_ingot'),
  makeArmorRecipe('gold_leggings', 'gold_ingot'),
  makeArmorRecipe('gold_boots', 'gold_ingot'),
  makeArmorRecipe('diamond_helmet', 'diamond_gem'),
  makeArmorRecipe('diamond_chestplate', 'diamond_gem'),
  makeArmorRecipe('diamond_leggings', 'diamond_gem'),
  makeArmorRecipe('diamond_boots', 'diamond_gem')
].filter(Boolean);
